module.exports = __webpack_public_path__ + "static/ru-sm-2-59659a8a08d3bf59e9aa2b26f21a87bc.png";